export function ApplyViaOtta(
  props: React.SVGAttributes<SVGSVGElement>
): React.ReactElement {
  return (
    <svg
      width="66"
      height="66"
      viewBox="0 0 66 66"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3 60.5C1.61929 60.5 0.5 61.6193 0.5 63C0.5 64.3807 1.61929 65.5 3 65.5V60.5ZM63 65.5C64.3807 65.5 65.5 64.3807 65.5 63C65.5 61.6193 64.3807 60.5 63 60.5V65.5ZM3 65.5H63V60.5H3V65.5Z"
        fill="black"
      />
      <path
        d="M8.5 43L6.73223 41.2322L6.17117 41.7933L6.03635 42.5752L8.5 43ZM20.5 55L20.9248 57.4636L21.7067 57.3288L22.2678 56.7678L20.5 55ZM59.5858 13.0858L57.818 14.8536L59.5858 13.0858ZM59.5858 15.9142L57.818 14.1464L59.5858 15.9142ZM47.5858 3.91421L45.818 2.14645L47.5858 3.91421ZM50.4142 3.91421L52.182 2.14645L50.4142 3.91421ZM6.4814 54.7079L4.01775 54.2831L6.4814 54.7079ZM8.79214 57.0186L8.36737 54.5549L8.79214 57.0186ZM8.94505 55.1326L10.9637 43.4248L6.03635 42.5752L4.01775 54.2831L8.94505 55.1326ZM10.2678 44.7678L49.3536 5.68198L45.818 2.14645L6.73223 41.2322L10.2678 44.7678ZM48.6464 5.68198L57.818 14.8536L61.3536 11.318L52.182 2.14645L48.6464 5.68198ZM57.818 14.1464L18.7322 53.2322L22.2678 56.7678L61.3536 17.682L57.818 14.1464ZM20.0752 52.5364L8.36737 54.5549L9.21691 59.4822L20.9248 57.4636L20.0752 52.5364ZM57.818 14.8536C57.6228 14.6583 57.6228 14.3417 57.818 14.1464L61.3536 17.682C63.1109 15.9246 63.1109 13.0754 61.3536 11.318L57.818 14.8536ZM49.3536 5.68198C49.1583 5.87724 48.8417 5.87724 48.6464 5.68198L52.182 2.14645C50.4246 0.389088 47.5754 0.389086 45.818 2.14645L49.3536 5.68198ZM4.01775 54.2831C3.48952 57.3468 6.15318 60.0105 9.21691 59.4822L8.36737 54.5549C8.70778 54.4963 9.00375 54.7922 8.94505 55.1326L4.01775 54.2831Z"
        fill="black"
      />
      <path d="M8 44L19 55" stroke="black" strokeWidth="5" />
      <path d="M40 10L52 22" stroke="black" strokeWidth="5" />
    </svg>
  );
}
